/**
 * Route definition for /itemdetails/:collId/:tokenId/page
 * Renders the LegacyRedirect component.
 *
 * This is a legacy route redirect for backwards compatibility.
 * Redirects old URL format to the new /item/:chain/:contract/:tokenId/ format.
 *
 * @module routes/itemdetails/$collId/$tokenId
 * @category Routes
 * @param {Object} params - Route parameters
 * @param {string} params.collId - The collection ID (contract address)
 * @param {string} params.tokenId - The token ID of the NFT
 */
import { createFileRoute } from '@tanstack/react-router'
import { Navigate, useParams } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/itemdetails/$collId/$tokenId/page')({
  component: LegacyRedirect,
})

/**
 * Legacy redirect component.
 * Redirects old itemdetails URLs to the new item route format.
 * Defaults to 'sgb' chain for the redirect target.
 *
 * @returns {React.ReactElement} Navigate component performing redirect
 */
function LegacyRedirect() {
  const { collId, tokenId } = useParams({})
  // Default to 'sgb' chain. In a real implementation, you might determine
  // the correct chain from the collection ID.
  return <Navigate to={`/item/sgb/${collId}/${tokenId}`} replace />
}